var exports = {
  "k": "x4ddf2309--256e4a--container",
};

module.exports = exports;
